import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RegisteredAddress } from "../../../domain/entities/undelivered";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listAddresses = createAsyncThunk<
  RegisteredAddress[],
  string,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_ADDRESSES, async (requestId, { extra }) => {
  return await extra.undeliveredRepo.listAddresses(requestId);
});
